/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'

type Props = {
  data: any
  className: string
  textHeader: string
  header: any
}

const rows: Array<{ description: string }> = [
  { description: 'Avg. Client Rating' },
  { description: 'Instagram Followers' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
  { description: 'Google Ads CPC' },
]

const ListBox = ({ className, textHeader, data, header }: Props) => (
  <div className={`card card-flush ${className} setScroll`} style={{ height: '250px', background: '#080655' }}>
    <div className='card-header pt-5'>
      <h3 className='card-title text-white fw-bold'>{textHeader}</h3>
      <div className='card-toolbar'></div>
    </div>
    <div className='card-body pt-5'>
      <Fragment key={`lw26-rows-${11}`}>
        <div className='d-flex flex-stack'>
          <button className='btn btn-icon   btn-sm h-auto btn-color-gray-600 btn-active-color-primary justify-content-end'>
            {header[0]}
          </button>
          <button
            type='button'
            className='btn btn-icon btn-sm h-auto btn-color-gray-600 btn-active-color-primary justify-content-end'
          >
            {header[1]}
            {/*<KTIcon iconName='exit-right-corner' className='fs-2' />*/}
          </button>
        </div>
        {<div className='separator separator-dashed my-3' />}
      </Fragment>
      {data.map((row: any, index: any) => (
        <Fragment key={`lw26-rows-${index}`}>
          <div className='d-flex flex-stack'>
            <a href='#' className='text-white fw-semibold fs-6 me-2'>
              {row.text}
            </a>
            <button
              type='button'
              className='btn btn-icon btn-sm h-auto btn-color-gray-600 btn-active-color-primary justify-content-end'
            >
              {row.number}
              {/*<KTIcon iconName='exit-right-corner' className='fs-2' />*/}
            </button>
          </div>
          {rows.length - 1 > index && <div className='separator separator-dashed my-3' />}
        </Fragment>
      ))}
    </div>
  </div>
)
export { ListBox }
